"use client";

import { I18nUtil } from "@utils/i18n";
import React from "react";
import { TextAreaField } from "@ospweb/sdk-ui";
import Translations from "@translate/components/Home/AppRating/AppSuggestionContentBody";

const I18n = I18nUtil.createScoped(Translations);

const MAX_LENGTH = 1000;

export interface AppSuggestionContentBodyProps {
  placeholder?: string;
  maxLength?: number;
  text: string;
  setText: (text: string) => void;
}

/** 建议态内容区：标题、描述、多行输入、字数 */
export const AppSuggestionContentBody: React.FC<
  AppSuggestionContentBodyProps
> = ({
  placeholder = "Tell us more...",
  maxLength = MAX_LENGTH,
  text,
  setText,
}) => {
  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const value = e?.target?.value ?? "";
    if (value.length <= maxLength) {
      setText(value);
    }
  };

  return (
    <div className="gap-6 flex flex-col">
      <div className="flex flex-col items-center gap-2 text-center">
        <h2
          aria-label="App Suggestion Content Body h2"
          data-openreplay-label="App Suggestion Content Body h2 Semantic"
          id="sem-app-suggestion-content-body-h2"
          className="headline_regular_s text-content_primary"
        >
          {I18n.t("How can we do better?")}
        </h2>
        <p className="body_m text-content_secondary">
          {I18n.t("Please let us know how we can enhance Edgen for you.")}
        </p>
      </div>
      <div className="flex w-full flex-col gap-2">
        <TextAreaField
          value={text}
          onChange={handleChange}
          placeholder={placeholder}
          maxLength={maxLength}
          borderVisible={true}
          autoSize={{ minRows: 5, maxRows: 8 }}
          containerClassName="min-h-[115px] w-full"
          placeholderClass="top-2 left-3 animate-none bg-none [-webkit-text-fill-color:unset] text-content_quaternary"
        />
        <p className="body_s text-right text-content_tertiary">
          {text.length}/{maxLength}
        </p>
      </div>
    </div>
  );
};
